import { supabase } from '@/integrations/supabase/client';

interface LeadSubmission {
  name: string;
  email: string;
  phone?: string;
  nationality?: string;
  programInterest?: string;
  subject?: string;
  message?: string;
  source: 'lead_capture' | 'contact_page';
  language?: string;
}

/**
 * Submit a lead to the CRM webhook edge function.
 * This saves to the database AND forwards to any configured CRM.
 */
export async function submitLead(data: LeadSubmission) {
  const { data: result, error } = await supabase.functions.invoke('crm-webhook', {
    body: data,
  });

  if (error) throw error;
  return result;
}
